//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "organisation-profile-sidebar",
	props: {
		organisation: {
			type: Object,
			required: true,
		},
		ranking: {
			type: Object,
			required: true,
		},
	},
	computed: {
		preferencesCountString() {
			return this.$store.getters["rankings/getRankingDescOrg"](this.ranking, this.$i18n.locale);
		},
	},
	data() {
		return {
			rankingViewName: "organisations-slug",
			rankingViews: [
				{
					name: "parliamentarians",
					path: "",
				},
				{
					name: "parties",
					path: "-parties",
				},
				{
					name: "factions",
					path: "-factions",
				},
			],
		};
	},
};
